import { IApiError } from '@frontend/request';

import {
  IGetMarketChartLatestParams,
  IGetMarketChartsParams,
  IGetMarketLiveChartsParams,
  IGetPriceLadderParams,
  ILatestChartTime,
  IMarketChartData,
  IPriceLadder,
  chartAPI
} from '@aqx-core/common/api/chart';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

import { isDummyOptionSymbol } from '../../market/controller/dummy';

class ChartAPIController {
  private priceLadderAC?: AbortController;
  private historicalChartAC?: AbortController;
  private latestChartAC?: AbortController;
  private latestAC?: AbortController;

  public getPriceLadder = async (params: IGetPriceLadderParams, callbacks: IAPIControllerCallbacks<IPriceLadder>) => {
    try {
      this.priceLadderAC?.abort();
      this.priceLadderAC = new AbortController();

      // ToDo: remove this after dummy data is removed
      if (isDummyOptionSymbol(params?.symbol)) {
        params.symbol = 'AAPL';
      }

      const { result } = await chartAPI.priceLadder(params, this.priceLadderAC.signal);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getHistoricalChartData = async (
    params: IGetMarketChartsParams,
    callbacks: IAPIControllerCallbacks<IMarketChartData[]>
  ) => {
    try {
      this.historicalChartAC?.abort();
      this.historicalChartAC = new AbortController();

      const { result } = await chartAPI.historicalChart(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getLatestBarData = async (
    params: IGetMarketLiveChartsParams,
    callbacks: IAPIControllerCallbacks<IMarketChartData>
  ) => {
    try {
      this.latestChartAC?.abort();
      this.latestChartAC = new AbortController();
      const { result } = await chartAPI.latestBarData(params, this.latestChartAC.signal);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getLatestChart = async (
    params: IGetMarketChartLatestParams,
    callbacks: IAPIControllerCallbacks<ILatestChartTime>
  ) => {
    try {
      this.latestAC?.abort();
      this.latestAC = new AbortController();

      const { result } = await chartAPI.latest(params, this.latestAC.signal);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const chartAPIController = new ChartAPIController();
